import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Icon } from '@blueprintjs/core';
import { setWeather, initWeather } from './WeatherSlice';
import { emit } from '../websocket/websocketSlice'
import './Weather.css';

/**
 * Weather Component
 *
 * This component provides an interface for selecting different weather conditions 
 * (sunny, raining, snowing). The selected weather condition updates both the Redux store 
 * and sends a command to Unity via a WebSocket to synchronize the state across different systems.
 *
 * The component displays three weather icons (sunny, raining, snowing), and users can 
 * toggle between them by clicking the corresponding icon. The currently selected weather 
 * is visually highlighted.
 *
 * Example:
 * <Weather />
 *
 * Notes:
 * - The component interacts with a WebSocket to send weather commands to Unity 
 *   (`emit({ type: 'manageWeather', command: 'sunny' })`).
 * - The weather state only reflects pure weather conditions (sunny, raining, snowing), 
 *   and additional data such as wind force or temperature is not currently processed.
 */
const Weather = () => {
    const dispatch = useDispatch();
    const weather = useSelector((state) => state.weatherManager.weather);
    //const weatherPreset = useSelector((state) => state.weatherManager.weatherPreset);

    // On component mount, initialize the session weather to the preset
    useEffect(() => {
        dispatch(initWeather());
    }, [dispatch]);

    // change the weather in the store and send the change to Unity if one of the buttons is used
    const handleWeatherChange = (newWeather) => {
        dispatch(setWeather(newWeather));  // Update session weather only
        emit({ type: 'manageWeather', command: newWeather });
    };

    return (
        <div className="weather-container">
            <div
                className={`weather-icon ${weather === 'sunny' ? 'active' : ''}`}
                onClick={() => handleWeatherChange('sunny')}
            >
                <Icon icon="flash" iconSize={32} />
            </div>
            <div
                className={`weather-icon ${weather === 'raining' ? 'active' : ''}`}
                onClick={() => handleWeatherChange('raining')}
            >
                <Icon icon="rain" iconSize={32} />
            </div>
            <div
                className={`weather-icon ${weather === 'snowing' ? 'active' : ''}`}
                onClick={() => handleWeatherChange('snowing')}
            >
                <Icon icon="snowflake" iconSize={32} />
            </div>
        </div>
    );
};

export default Weather;
